export default "__VITE_ASSET__4056c669__"